import * as types from "./ActionTypes"

export const API_REQUEST = "API_REQUEST"; // NB any action that contains this will be handled by api middleware
export const CANCEL_API_REQUEST = "CANCEL_REQUEST";
export const API_CALL_STARTED = "API_CALL_STARTED";
export const API_CALL_SUCCESS = "API_CALL_SUCCESS";
export const API_CALL_ERROR = "API_CALL_ERROR";
export const API_CALL_CANCELED = "API_CALL_CANCELED";

//API METHODS types
export const GET = "get";
export const POST = "post";
export const PUT = "put";

export const apiRequest = (url, method, entity, data = {}, config = {}, meta = null) => ({
   type: `${entity} ${API_REQUEST}`,
   payload: {
       url,
       method,
       entity,
       data,
       config,
       meta
   }
});

export const apiCallSuccess = (data, entity = "", meta = null) => ({
    type: `${entity} ${API_CALL_SUCCESS}`,
    payload: {
        data,
        entity,
        meta
    }
});

export const apiCallError = (error, entity = "", meta = null) => ({
    type: `${entity} ${API_CALL_ERROR}`,
    payload: {
        error,
        meta
    }
});

export const apiCallCancelled = (entity = "") => ({
    type: `${entity} ${API_CALL_CANCELED}`,
});


export const apiCallStarted = (entity = "") => ({
    type: `${entity} ${API_CALL_STARTED}`,
});

export const cancelRequest = (entity) => ({
    type: CANCEL_API_REQUEST,
    payload: {
        entity
    }
});
